/**
 * 事件编辑器解析：按 Code 查找专用组件，或回退到 schema 自动生成 / 空白占位。
 */
import { defineAsyncComponent, type Component } from 'vue'
import EventEditorAuto from './EventEditorAuto.vue'
import EventEditorBlank from './EventEditorBlank.vue'
import { getEventSchema } from './eventEditorSchema'

/** 按文件名 glob 懒加载 EventByCode*.vue 专用编辑器。 */
const loaders = import.meta.glob<{ default: Component }>('./EventByCode*.vue')

/**
 * 判断当前事件是否已有可编辑属性界面。
 * @param code 事件 Code
 */
export function hasEventEditor(code: number): boolean {
  return Boolean(loaders[`./EventByCode${code}.vue`] || getEventSchema(code))
}

/**
 * 按事件 Code 解析专用编辑器；无对应文件或 schema 时保持空白。
 * @param code 事件 Code
 * @returns 可挂载的编辑器组件
 */
export function resolveEventEditor(code: number): Component {
  const key = `./EventByCode${code}.vue`
  const load = loaders[key]
  if (load) {
    return defineAsyncComponent(load)
  }
  if (!getEventSchema(code)) {
    return EventEditorBlank
  }
  return EventEditorAuto
}
